import * as React from 'react';

function SvgSpringMinus8(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.685 24.637v6.69l-10.052 6.281 20.103 12.561-20.103 12.562 20.103 12.561-20.103 12.562 20.103 12.561-20.103 12.561 20.103 12.562-20.103 12.561 20.103 12.562-20.103 12.561 20.103 12.561-10.051 6.281v6.69"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path
        d="M20.185 235.68v2.587l-17.402 3.494 20.1 4.035-20.1 4.036 20.103 4.036-20.103 4.036 20.1 4.037-20.1 4.035 20.103 4.036-20.103 4.036 20.1 4.035-20.1 4.036 20.103 4.037-2.7.542v5.538h5v-2.586l17.401-3.494-20.103-4.037 20.103-4.034-20.105-4.037 20.105-4.036-20.105-4.036 20.105-4.037-20.103-4.035 20.103-4.036-20.105-4.036 20.105-4.036-20.103-4.035 2.701-.543v-5.538h-5z"
        fill={props.springcolor}
      />
      <path
        d="M45.154 213.5a22.501 22.501 0 01-38.41 15.91A22.502 22.502 0 0122.654 191a22.502 22.502 0 0122.5 22.5z"
        fill="#5BAD92"
      />
      <path
        d="M31.587 196.154a.896.896 0 00-.618 1.112.9.9 0 00.428.54 17.645 17.645 0 012.938 2.04 17.861 17.861 0 014.289 5.428 18.139 18.139 0 011.68 4.879 17.964 17.964 0 01.22 5.212 17.819 17.819 0 01-.726 3.502 18.128 18.128 0 01-3.491 6.314v.001a17.96 17.96 0 01-3.932 3.426 17.903 17.903 0 01-3.066 1.578 18.128 18.128 0 01-5.025 1.208 18.011 18.011 0 01-3.495-.022 17.99 17.99 0 01-3.501-.726.905.905 0 00-.96.28.91.91 0 00-.207.657.893.893 0 00.319.611c.09.076.195.133.308.169a19.79 19.79 0 003.854.8 19.883 19.883 0 003.847.023 19.543 19.543 0 003.735-.711 19.895 19.895 0 005.164-2.352 19.952 19.952 0 003-2.365 19.685 19.685 0 004.463-6.456 19.964 19.964 0 001.204-3.817 19.653 19.653 0 00.058-7.669 19.773 19.773 0 00-1.063-3.639 19.959 19.959 0 00-1.734-3.372 19.78 19.78 0 00-3.772-4.327 19.457 19.457 0 00-3.233-2.246.898.898 0 00-.684-.078zM22.775 193.731a20.027 20.027 0 00-3.804.349 20.013 20.013 0 00-3.64 1.063 19.908 19.908 0 00-3.37 1.734 19.706 19.706 0 00-7.464 8.821 19.97 19.97 0 00-1.204 3.817 19.609 19.609 0 00-.324 5.781 19.746 19.746 0 001.329 5.527 19.95 19.95 0 001.734 3.372 19.787 19.787 0 002.365 3 19.587 19.587 0 002.955 2.523c.54.375 1.101.726 1.685 1.05a.902.902 0 001.223-.35.899.899 0 00-.35-1.223 17.916 17.916 0 01-5.358-4.561 18.025 18.025 0 01-3.144-6.108 17.975 17.975 0 01-.625-6.89 17.801 17.801 0 01.727-3.502 18.184 18.184 0 012.405-4.909 17.686 17.686 0 012.292-2.684 17.959 17.959 0 017.422-4.288 17.823 17.823 0 013.395-.647 18.012 18.012 0 013.495.022 17.697 17.697 0 013.501.727.905.905 0 001.129-.589.898.898 0 00-.589-1.129 19.787 19.787 0 00-3.854-.799 19.577 19.577 0 00-1.931-.107z"
        fill="#FCFAF2"
      />
      <path
        d="M29.709 196.096l-5.619 1.463 1.539-5.586 4.08 4.123z"
        fill="#F9AEA5"
      />
      <path
        d="M25.669 191.546a.434.434 0 00-.455.313l-1.538 5.586a.429.429 0 00.523.529l5.618-1.463a.429.429 0 00.197-.716l-4.08-4.123a.432.432 0 00-.265-.126zm.177 1.256l3.034 3.067-4.178 1.088 1.144-4.155z"
        fill="#FCFAF2"
      />
      <path
        d="M15.6 230.904l5.618-1.463-1.539 5.586-4.08-4.123z"
        fill="#F9AEA5"
      />
      <path
        d="M21.288 229.018a.447.447 0 00-.179.008l-5.618 1.463a.43.43 0 00-.197.716l4.08 4.123a.426.426 0 00.414.114.429.429 0 00.305-.301l1.539-5.586a.428.428 0 00-.345-.537zm-.682 1.025l-1.144 4.155-3.034-3.067 4.178-1.088zM22.654 227.196h2.683v-6.443h5.594v-2.473h-5.626v-2.473h5.626v-2.474h-4.155l6.564-11.574h-5.885l-4.801 9.683v15.754zm0 0H19.97v-6.443h-5.593v-2.473h5.626v-2.473h-5.626v-2.474h4.155l-6.564-11.574h5.885l4.8 9.683"
        fill="#FCFAF2"
      />
      <path
        d="M34.218 0h-23v23h23V0zM34.218 292h-23v23h23v-23z"
        fill="#5BAD92"
      />
    </svg>
  );
}

export default SvgSpringMinus8;
